// utils/alert.ts
import { Alert, Platform } from "react-native";

type AlertButton = {
  text: string;
  onPress?: () => void;
  style?: "default" | "cancel" | "destructive";
};

export const showAlert = (
  title: string,
  message?: string,
  buttons?: AlertButton[],
): void => {
  if (Platform.OS === "web") {
    // Simple web fallback – show alert/confirm based on button count
    if (!buttons || buttons.length === 0) {
      window.alert(title + (message ? `\n${message}` : ""));
      return;
    }
    // Only one button – show alert and call its onPress
    if (buttons.length === 1) {
      window.alert(title + (message ? `\n${message}` : ""));
      if (buttons[0]?.onPress) buttons[0].onPress();
      return;
    }
    // Two buttons – use confirm (Cancel/OK pattern)
    if (buttons.length === 2) {
      const ok = window.confirm(title + (message ? `\n${message}` : ""));
      if (ok) {
        const actionBtn = buttons.find(
          (b) => b.style !== "cancel" && b.text !== "Cancel",
        );
        if (actionBtn?.onPress) actionBtn.onPress();
      } else {
        const cancelBtn = buttons.find(
          (b) => b.style === "cancel" || b.text === "Cancel",
        );
        if (cancelBtn?.onPress) cancelBtn.onPress();
      }
      return;
    }
    // More than 2 buttons – just alert and call first button
    window.alert(title + (message ? `\n${message}` : ""));
    if (buttons[0]?.onPress) buttons[0].onPress();
  } else {
    Alert.alert(title, message, buttons);
  }
};
